import React, {useEffect, useState} from 'react';
import apiJSON from "../../../api/apiJSON";
import {gsap} from 'gsap'
import _ from 'lodash'
import {Draggable} from "gsap/Draggable";
import {useSelector} from "react-redux";
import "./StackSorting.sass"
import EnhancedPopUp from "../../ui/PopUp/EnhancedPopUp";
import {STATUS_PAUSED,STATUS_PLAYING,STATUS_FINISHED} from '../../../store/utils/audio.status'
import StackSortingModel from "./StackSortingModel";

const StackSorting = ({data, completed, next}) => {

    const jsonData = apiJSON.get(data);
    const {scenario} = jsonData;
    const [sortingModel, setSortingModel] = useState(new StackSortingModel());
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [feedbackAlert, setFeedbackAlert] = useState(null);
    const [feedback,setFeedback] = useState(null);
    const audioStatus = useSelector((state)=>state.course.audioStatus)
    const [enabled,setEnabled] = useState(true);

    gsap.registerPlugin(Draggable);

    useEffect(() => {
        console.log("StackSorting ()");
        if (sortingModel) {
            initDrags(".stack-sorting-drag");
            registerDrops(document.querySelectorAll(".stack-sorting-field"));
        }
    }, [])

    /*useEffect(() => {
        switch (audioStatus){
            case STATUS_FINISHED:
                setEnabled(true);
                return;
            case STATUS_PLAYING:
            case STATUS_PAUSED:
                setEnabled(false);
                return;
        }
    }, [audioStatus]);*/


    useEffect(() => {
        if (feedbackAlert) {
            let tl = gsap.timeline({onComplete: advance});
            tl.fromTo(".stack-sorting-alert", {"opacity": 0, "duration": 0.5}, {"opacity": 1});
            tl.to(".stack-sorting-alert", {"opacity": 0, "delay": 1, "duration": 0.5})
            tl.play();
        }

    }, [feedbackAlert])


    const advance = () => {
        setFeedbackAlert(null);
        console.log("StackSorting advance()");
        //reset target
        let dragChoice = scenario.drags[selectedIndex];
        let dragProxy = sortingModel.getDragProxy(dragChoice.id);
        if (dragProxy.drop.id !== dragChoice.target) {
            console.log("   dragProxy.drop.drags: ", dragProxy.drop.drags);
            _.remove(dragProxy.drop.drags,(d)=>{return d.id===dragProxy.id})
            //incorrect, move to correct target
            let dropProxy = sortingModel.getDropProxy(dragChoice.target);
            setDropTarget(dragProxy,dropProxy);
        }
        if(selectedIndex+1<scenario.drags.length){
            setSelectedIndex(selectedIndex+1)
        }
        else
        {
            setFeedback(scenario.feedback)
        }
    }

    const registerDrops = (drops) => {
        let dc=[]
        _.map(drops, (d, i) => {
            let drop = {"id": d.id, "index":i, "target": d, "drags": []}
            sortingModel.addDropProxy(drop);
            dc.push(0)
        });
        return dc
    }

    const initDrags = (dragClassName) => {
        var drags = document.querySelectorAll(dragClassName);
        _.map(drags, (d, i) => {
            let drag = Draggable.create("#" + d.id, {type: "x,y"}, [0])
            let dragProxy = {
                "id": d.id,
                "index":i,
                "draggable": drag[0],
                "target": drag[0].target,
                "startX": drag[0].x,
                "startY": drag[0].y
            }
            sortingModel.addDragProxy(dragProxy);
            drag[0].addEventListener("dragstart", onDragStart);
            drag[0].addEventListener("dragend", onDragEnd);
        })
    }

    const disableDrag = (id) => {
        var drag = sortingModel.getDragProxy(id);
        drag.draggable.disable()
    }

    const onDragStart = (drag) => {
        let dragProxy = sortingModel.getDragProxy(drag.target.id);
        if (dragProxy.drop) {
            dragProxy.drop.drag = null;
        }
        dragProxy.drop = null;
    }

    const setDropTarget = (dragProxy,hitProxy) =>{
        console.log("StackSorting setDropTarget(",dragProxy,hitProxy,")");
        let destX, destY
        let style = getComputedStyle(hitProxy.target);
        destY = (getOffset(hitProxy.target).top - getOffset(dragProxy.target).top) + parseInt(style.paddingBottom)
        destX = (getOffset(hitProxy.target).left - getOffset(dragProxy.target).left) + parseInt(style.paddingBottom)
        for(let i=0;i<hitProxy.drags.length;i++){
            destY += dragProxy.target.offsetHeight + (!isNaN(parseInt(style.gap))?parseInt(style.gap):0);
        }
        
        gsap.to(dragProxy.target, {
            duration: 0.2,
            x: destX,
            y: destY
        });

        if ((hitProxy.drags.indexOf(dragProxy) === -1)) {
            hitProxy.drags.push(dragProxy)
        }
    }
    

    const checkHit = (drag) => {
        console.log("StackSorting checkHit(",drag,")");
       let hitTarget = null
        let hitProxy = null
        let dragProxy = sortingModel.getDragProxy(drag.target.id)
        sortingModel.getDropMap().forEach((dropProxy) => {
            if (dragProxy.draggable.hitTest(dropProxy.target, "50%") && !hitTarget && !dropProxy.disabled) {
                console.log("      hit detected!")
                hitTarget = dropProxy.target;
                hitProxy = dropProxy;
            }
        });
        if (hitProxy) {
            setDropTarget(dragProxy,hitProxy);
            dragProxy.drop = hitProxy;
            disableDrag(dragProxy.id)

        } else {
            dragProxy.drop = null;
            gsap.to(dragProxy.target, {x: dragProxy.startX, y: dragProxy.startY})
        }
        if (hitProxy) {
            let dragChoice = _.find(scenario.drags, {"id": dragProxy.id});
            if (dragChoice.target === hitProxy.id) {
                //show correct alert
                console.log("correct!!!")
                let fb
                if (dragChoice.feedback) {
                    setFeedbackAlert(dragChoice.feedback)
                } else if (scenario.feedback) {
                    setFeedbackAlert(_.find(scenario.alerts,{"id":"correct"}))
                }
            } else {
                if (dragChoice.feedback) {
                    setFeedbackAlert(dragChoice.feedback)
                } else{
                    setFeedbackAlert(_.find(scenario.alerts,{"id":"incorrect"}))
                }
            }
        }
    }

    const getOffset = (element) => {
        let top = 0, left = 0;
        do {
            top += element.offsetTop || 0;
            left += element.offsetLeft || 0;
            element = element.offsetParent;
        } while (element);

        return {
            top: top,
            left: left
        };
    };

    const onDragEnd = (drag) => {
        checkHit(drag);
    }

    const finish = ()=>{
        completed();
        next();
    }

    return (
        <div className="StackSorting">
            {
                feedback&&
                    <EnhancedPopUp data={feedback} onHide={finish}/>
            }
            {feedbackAlert &&
            <div className="stack-sorting-alert">
                <div className="stack-sorting-alert-panel">
                    {
                        feedbackAlert.title &&
                        <div className="stack-sorting-alert-title">{feedbackAlert.title}</div>
                    }
                    {
                        feedbackAlert.body &&
                        <div className="stack-sorting-alert-body">{feedbackAlert.body}</div>
                    }
                </div>
            </div>}
            <div className="stack-sorting-field-row">
                {
                    scenario.drops.map((drop, index) => (
                            <div className="stack-sorting-field-holder"
                                 key={"drop-holder" + index}>
                                <div className="stack-sorting-field-label">
                                    {drop.label}
                                </div>
                                <div id={"drop" + index}
                                     className="stack-sorting-field">
                                </div>
                            </div>
                        )
                    )
                }
            </div>
            <div className="stack-sorting-drag-row">
                <div className="stack-sorting-drag-holder">
                    {
                        scenario.drags.map((drag, index) => (
                            <div className={"stack-sorting-drag" + (index>selectedIndex?" invisible":(index<selectedIndex||feedback)?" disabled":(enabled?"":" invisible"))}

                                 key={"drag" + index}
                                 id={"drag" + index}>
                                {drag.label}
                            </div>
                        ))
                    }

                </div>
            </div>
            <div className="stack-sorting-instrux">
                {scenario.body}
            </div>
        </div>
    );
};

export default StackSorting;